import { render, staticRenderFns } from "./datatable3.vue?vue&type=template&id=615a21d7"
import script from "./datatable3.vue?vue&type=script&lang=js"
export * from "./datatable3.vue?vue&type=script&lang=js"
import style0 from "./datatable3.vue?vue&type=style&index=0&id=615a21d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports